var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-sheet',{staticClass:"d-flex align-center justify-center",attrs:{"color":_vm.color,"height":_vm.height}},[_c('v-progress-circular',{attrs:{"indeterminate":"","color":_vm.colorCircular,"size":_vm.size,"width":"2"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }